
































import Vue from 'vue'
import { TransferDirectoryGroupServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'

const transferDirectoryGroupServiceProxy = new TransferDirectoryGroupServiceProxy()
export default Vue.extend({
  name: 'AddOrEditDirectoryGroup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      // 0 新增子目录，1 重命名
      type: String,
      default: '0'
    },
    directoryGroupParams: {
      // 新增子目录时：{parentAllPath，parentId}  重命名时：{id,name}
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.loading = false
          if (this.type === '0') {
            this.form = this.$form.createForm(this)
          } else {
            this.form = this.$form.createForm(this, {
              mapPropsToFields: () => {
                let fields = {
                  name: this.$form.createFormField({
                    value: this.directoryGroupParams.name
                  })
                }
                return fields
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    handleOk() {
      this.loading = true
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.loading = false
          return
        }

        let params = {
          ...this.directoryGroupParams,
          ...values
        }
        // console.log('params:', params)
        if (this.type === '0') {
          // 新增子目录
          transferDirectoryGroupServiceProxy
            .save(params)
            .then((res: any) => {
              // console.log('保存分组', res)
              if (res) {
                this.$emit('close', true)
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          // 重命名
          transferDirectoryGroupServiceProxy
            .update(params)
            .then((res: any) => {
              if (res) {
                this.$emit('close', true)
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.$emit('close')
    }
  }
})
